var timeout = false, rtime,delta = 500;

$(function(){ 

	$('.mobile-menu-modal').on('shown.bs.modal', function (e) {
	  	$('.mobile-menu-trigger').addClass('menu-visible');
	});
	
	$('.mobile-menu-modal').on('hidden.bs.modal', function (e) {
	  	$('.mobile-menu-trigger').removeClass('menu-visible');
	});

	$('.mobile-menu-modal .messages-notifications').on('click', function () {
		$('.mobile-menu-modal').modal('hide');
		$('.mobile-menu-modal').on('hidden.bs.modal', function () {
			 $('.notification-modal').modal('show');
		});
		return false;
	});  
	
	$('.expand-menu-toggle').on('click', function () {
		$('.desktop-menu.menu-side-w.menu-activated-on-click').toggleClass('expanded');
		return false;
	});

    $('.go-to-anchor').click(function(){
        var anchor = $(this).attr('href');
        $("html, body").animate({ scrollTop: $(anchor).offset().top }, 1000);    
        return false;
    });    

    $('.iframe-lang-switch ul li span.lang').click(function(){
        var $this = $(this);
        
        $('.iframe-lang-switch ul li span.lang').removeClass('active');
        
        $this.addClass('active');
        
        var $source = $this.data('source');

        $this.closest('.embed-block').find('iframe').attr('src',$source);

        return false;

    });

    initForm('body');

    
}); 

function waypoints(){

    $('.way-point:not(.way-point-ready)').each(function(){
        
        $(this).waypoint(function() {
            
            $(this.element).addClass('shown');

        }, {offset: '90%'}); 
        
        $(this).addClass('way-point-ready');

    });
    
}

function initForm(target){
	'use strict';

	waypoints();

	$('.select2,select[data-plg="select2"]:visible').each(function(){
		var data = $(this).data();
	    var options = {};
	    if(data.ajax){
	        options = $.extend(false, options ,{
	            placeholder: data.placeholder,
	            allowClear: data.allowClear || false,
	            ajax: {
	                url : API + '/'+ data.ajax,
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    var search_for = typeof(params.term)!=='undefined'?params.term:'';
	                    return {
	                        q: data.search+'=@'+search_for,
	                        page: params.page
	                    };
	                },
	                processResults: function (res, params) {
	                    params.page = params.page || 1;
	                    var value_field = data.value || 'id';
	                    var label_field = data.label || data.search;
	                    return {
	                        results:  $.map(res.data, function (item) {
	                            return { 
	                                all_data: item,
	                                text: item[label_field],
	                                id: item[value_field]
	                            }
	                        }),
	                        pagination: {
	                            more: (params.page * 30) < data.total_count
	                        }
	                    };
	                },
	                cache: true
	            },
	            minimumInputLength: 0
	        });
	    }
	    $(this).select2(options);
	});

}

function actionResponseModal(msg, type, container){
	var $timeout = 0;
	
	/*if($('body').hasClass('modal-open') ){
		$('.modal').modal('hide');
		$timeout = 500;	
	}*/
	var with_ajax_modal = false;
	if($('#ajaxModal:visible').length == 1){
		with_ajax_modal = true;
		$('#ajaxModal').animate({opacity:0},300);
	}

	setTimeout(function(){

        var $d = '<div class="modal fade" id="responseModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">\
                <div class="modal-dialog modal-md" role="document">\
                    <div class="modal-content">\
                        <a href="#" class="close-modal" tabindex="0" onClick="$(\'#responseModal\').modal(\'hide\');return false;">\
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" viewBox="0 0 13 13" style="enable-background:new 0 0 13 13;" xml:space="preserve">\
                                <path class="st0" d="M12.9,11.7l-1.2,1.2L6.9,8.1l-4.8,4.8l-1.2-1.2l4.8-4.8L0.9,2.1l1.2-1.2l4.8,4.8l4.8-4.8l1.2,1.2L8.1,6.9 L12.9,11.7z"></path>\
                            </svg>\
                        </a>\
                        <div class="modal-body"></div>\
                    </div>\
                </div>\
            </div>';
        if( $('#responseModal').length == 0 ){
            $('body').append($d);
        }
        
		var _container = container || '';
		if(type == 'success'){
			var icon = '<i class="fa fa-check-circle" aria-hidden="true"></i>';	
		}else{
			var icon = '<i class="fa fa-exclamation-circle" aria-hidden="true"></i>';	
		}
		var content = '<div class="alert alert-'+type+'"><h3>'+msg+'</h3></div>'
		$('#responseModal .modal-body').html(content);	
		$('body').addClass('dark-backdrop');
		$('#responseModal').modal('show');
		$('#responseModal').on('hidden.bs.modal', function () {
			$('#responseModal .modal-body').empty();
			$('body').removeClass('dark-backdrop');
			if(with_ajax_modal){
				$('#ajaxModal').animate({opacity:1},300);
			}
		});
	},$timeout);

}

 function loadScript(url, callback) {
    jQuery.ajax({
        url: url,
        dataType: 'script',
        success: callback,
        async: true
    });
}
function load_css (t){
	$('head').append('<link rel="stylesheet" href="'+t+'" type="text/css" />');
}